export const RUC_EMPRESA = '1790295168001'